<template>
  <div class="overlay-pop">
    <div class="overlay-pop--box gallery">
      <!-- {{children}} -->
      <slot name="close"></slot>
      <aslider
        animation="fade"
        :autoplay="false"
        height="100%"
        :indicators="slideCount > 1 ? 'center' : false"
        :control-btn="slideCount > 1"
        :class="['slider-gallery']"
        v-model="index"
      >
        <!-- :class="[isGallery ? 'slider-gallery' : '']" -->
        <preloader v-if="!mediaReady"></preloader>
        <slider-item v-else v-for="(item, index) in children" :key="index">
          <div class="slider-item--content">
            <template>
              <img
                v-if="item.media_type_id === mediaTypes.image"
                :src="item.image"
                :alt="item.title"
              />
             <iframe
                width="560"
                height="315"
                :src="item.src"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </template>
          </div>
        </slider-item>
      </aslider>
    </div>
  </div>
</template>
<script>
// import LazyYoutubeVideo from "vue-lazy-youtube-video";
import { mapActions } from "vuex";
import { Slider, SliderItem } from "vue-easy-slider";
export default {
  props: {
    children: {
      type: Array,
      required: false
    },
    isGallery: {
      type: Boolean,
      default: false
    },
    sliderIndex: {
      type: Number,
      default: -1
    }
  },
  components: {
    aslider: Slider,
    SliderItem
    // LazyYoutubeVideo
  },
  data() {
    return {
      mediaTypes: {
        video: 5,
        image: null //4 TEMPORARY >> Videos are still with this ID so, I'm dropping it to avoid bugs.
      },
      mediaReady: false,
      index: -1
    };
  },
  created() {
    this.index = this.sliderIndex;
    this.setChildrenSrc();
  },
  watch: {
    sliderIndex() {
      this.mediaReady = false;
      this.index = this.sliderIndex;
    },
    index() {
      this.mediaReady = true;
    },
    children() {
      this.setChildrenSrc();
    }
  },
  mounted() {
    this.bindKeyEvents();
  },
  destroyed() {
    this.unbindKeyEvents();
  },
  methods: {
    ...mapActions(["setGalleryIndex"]),
    bindKeyEvents() {
      document.addEventListener("keyup", this.keyupHandler, false);
    },
    unbindKeyEvents() {
      document.removeEventListener("keyup", this.keyupHandler, false);
    },
    frameError(e) {
      console.log("frame err > ", e);
    },
    setChildrenSrc() {
      this.mediaReady = false;
      if (this.children && this.children.length) {
        let vm = this;
        this.children.forEach(child => {
          child.src = vm.parseSrc(child.url);
        });
      }
      setTimeout(
        function() {
          this.mediaReady = true;
        }.bind(this),
        200
      );
    },
    keyupHandler(e) {
      if (e.key) {
        if (e.key === "Escape") {
          this.setGalleryIndex(-1);
        } else {
          let _i,
            i = this.index,
            last = this.slideCount - 1;
          if (e.key === "ArrowRight") {
            _i = i === last ? 0 : i + 1;
          } else if (e.key === "ArrowLeft") {
            _i = i === 0 ? last : i - 1;
          } else {
            return false;
          }
          this.setGalleryIndex(_i);
        }
      }
    },
    // frameLoaded() {
    //   this.mediaReady = true;
    // },
    fetchId(url) {
      let code = /[A-Za-z0-9]+/g,
        match = url.match(code);
      return _.last(match);
    },
    parseSrc(src) {
      // return "wecftv6jor4";
      // let id = this.$youtube.getIdFromURL(src)
      // return id;
      if(src.indexOf("player.vimeo.com")>-1)
      {
        return src;
      }
      if (src.indexOf("vimeo") > -1) {
        let code = src.match(/[0-9]+/g)[0];
        return `https://player.vimeo.com/video/${code}`;
      } else if (src.indexOf("youtu.be") > -1) {
        let code = src.split("/");
        return `https://www.youtube.com/embed/${code[code.length - 1]}`;
      }
      if (src.indexOf("/") < 0) {
        // let code = src.match(/[0-9]+/g)[0];
        return `https://www.youtube.com/embed/${src}`;
      }
      return src;
    }
    // parseTitle(title) {
    //   if (title.indexOf("@") > -1) {
    //     // RETURN SVG
    //     let svg = title.substring(1);
    //     return `<img src="/img/product-logos/${svg}.svg" />`;
    //   }
    //   return title;
    // }
  },
  computed: {
    slideCount() {
      return this.children.length;
    },
    currentSrc() {
      return this.children[this.index].src;
    }
  }
};
</script>
<style lang="stylus">

.close-overlay
  position absolute
  top 2vmin
  right 2vmin
  z-index 1001
  color gray_3
  font-size 4vmin
  display block
  cursor pointer
  // transition opacity 0.3s ease-out
  hoverize(gray_8, color)
.gallery
  // position fixed
  // top 90px
  // left 0
  // width 100%
  // height calc(100% - 90px)
  // background rgba(gray_0, 0.99)
  // z-index 100
  // +below(615px)
  //   top 60px
  .preloader
    opacity 0.2
  .slider-indicators
    left 50%
    transform translateX(-50%)
    +below(815px)
      bottom 8px
  .slider-indicator-active
    background rgba(gray_8, 0.8) !important
  .slider
    height 100% !important
    &-item
      _flex(row, nowrap, center, center)
      &--content
        width 90%
        height 90%
        +below(815px)
          width 80%
          max-height 80%
        iframe
        img
          width 100%
          height 96%
      // position absolute
      // top 50%
      // left 50%
      // transform translate(-50%,-50%)
</style>
